import React from 'react';

import { useIsAuthenticated } from '@azure/msal-react';

import { AQA_ELEMENTS_MARKER_LIST } from 'features/order-tracker/utils/aqaElementsIDList';

import { ExternalLink } from '../ExternalLink';

import styles from './styles.module.scss';

interface LinkItem {
  id: string | number;
  link: string;
  text: string;
  [key: string]: unknown;
}

interface UsefulLinksProps {
  links: LinkItem[];
}

export function UsefulLinks({ links }: UsefulLinksProps) {
  const isAuthenticated = useIsAuthenticated();

  return (
    <ul className={styles.usefulLinks}>
      {links.map((linkItem) => {
        const isMyAccountLink = linkItem.id === 'myAccount';
        const REACT_APP_MY_ACCOUNT_DOMAIN = import.meta.env.VITE_MY_ACCOUNT_DOMAIN;
        const link =
          isMyAccountLink && isAuthenticated ? `${REACT_APP_MY_ACCOUNT_DOMAIN}/Account/Dashboard` : linkItem.link;
        const target = isMyAccountLink && isAuthenticated ? '_self' : '_blank';

        return (
          <li id={AQA_ELEMENTS_MARKER_LIST.summaryPage.orderSummary.usefulLinks[linkItem.id]} key={linkItem.id}>
            <ExternalLink
              {...linkItem}
              key={linkItem.link}
              target={target}
              link={link}
              iconClassName={styles.internalLinkSvg}
            />
          </li>
        );
      })}
    </ul>
  );
}
